import React, { useCallback, useMemo, useState } from "react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { Slate, Editable, withReact } from "slate-react";

// import Toolbar from "./ToolBar/Toolbar.jsx";
import "./Editor.css";
import Toolbar from "./Toolbar";
import { createPortal } from "react-dom";

const Element = (props: any) => {
  const { attributes, children, element }: any = props;

  switch (element.type) {
    case "headingOne":
      return <h1 {...attributes}>{children}</h1>;
    case "headingTwo":
      return <h2 {...attributes}>{children}</h2>;
    case "headingThree":
      return <h3 {...attributes}>{children}</h3>;
    case "blockquote":
      return <blockquote {...attributes}>{children}</blockquote>;
    case "alignLeft":
      return (
        <div
          style={{ textAlign: "left", listStylePosition: "inside" }}
          {...attributes}
        >
          {children}
        </div>
      );
    case "alignCenter":
      return (
        <div
          style={{ textAlign: "center", listStylePosition: "inside" }}
          {...attributes}
        >
          {children}
        </div>
      );
    case "alignRight":
      return (
        <div
          style={{ textAlign: "right", listStylePosition: "inside" }}
          {...attributes}
        >
          {children}
        </div>
      );
    case "list-item":
      return <li {...attributes}>{children}</li>;
    case "orderedList":
      return (
        <ol type="1" {...attributes}>
          {children}
        </ol>
      );
    case "unorderedList":
      return <ul {...attributes}>{children}</ul>;

    case "table":
      return (
        <table>
          <tbody {...attributes}>{children}</tbody>
        </table>
      );
    case "table-row":
      return <tr {...attributes}>{children}</tr>;
    case "table-cell":
      return <td {...attributes}>{children}</td>;
    default:
      return <p {...attributes}>{children}</p>;
  }
};
const Leaf = ({ attributes, children, leaf }: any) => {
  if (leaf.lineHeight) {
    children = <span style={{ lineHeight: leaf.lineHeight }}>{children}</span>;
  }

  if (leaf.letterSpacing) {
    children = (
      <span style={{ letterSpacing: leaf.letterSpacing }}>{children}</span>
    );
  }
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.weight) {
    children = <span style={{ fontWeight: leaf.weight }}>{children}</span>;
  }
  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }
  if (leaf.strikethrough) {
    children = (
      <span style={{ textDecoration: "line-through" }}>{children}</span>
    );
  }
  if (leaf.underline) {
    children = <u>{children}</u>;
  }
  if (leaf.superscript) {
    children = <sup>{children}</sup>;
  }
  if (leaf.subscript) {
    children = <sub>{children}</sub>;
  }
  if (leaf.color) {
    children = <span style={{ color: leaf.color }}>{children}</span>;
  }
  if (leaf.bgColor) {
    children = (
      <span style={{ backgroundColor: leaf.bgColor }}>{children}</span>
    );
  }
  if (leaf.fontSize) {
    children = (
      <span style={{ fontSize: leaf.fontSize || undefined }}>{children}</span>
    );
  }
  if (leaf.fontFamily) {
    children = <span style={{ fontFamily: leaf.fontFamily }}>{children}</span>;
  }

  if (leaf.lineHeight) {
    children = <span style={{ lineHeight: leaf.lineHeight }}>{children}</span>;
  }
  return <span {...attributes}>{children}</span>;
};
const Editor = ({
  onChange,
  id,
  value,
  defaultType,
  openEditor,
  setOpen,
}: any) => {
  const editor = useMemo(() => withHistory(withReact(createEditor())), []);

  const getInitialValue = (val: any) => {
    if (Array.isArray(val)) {
      return val;
    }

    return [
      {
        type: defaultType || "paragaph",
        children: [{ text: val?.value || "" }],
      },
    ];
  };

  const renderElement = useCallback((props: any) => <Element {...props} />, []);

  const renderLeaf = useCallback((props: any) => {
    return <Leaf {...props} />;
  }, []);

  return (
    <Slate
      editor={editor}
      initialValue={getInitialValue(value)}
      onChange={(newValue) => {
        if (onChange) onChange(newValue, id);
      }}
    >
      {openEditor && createPortal(<Toolbar setOpen={setOpen} />, document.body)}
      <div
        className="editor-wrapper"
        style={{
          padding: "0 10px",
          outline: "none",
        }}
      >
        <Editable
          placeholder="Escribe tu texto..."
          renderElement={renderElement}
          renderLeaf={renderLeaf}
        />
      </div>
    </Slate>
  );
};

export default Editor;
